/* Nette v2 (NETTE-04). Movimento só na 1ª vez que a seção aparece e quando a pessoa age; uma coisa se move por vez; "reduzir movimento" = tudo parado. */
(() => {
  const reduz = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const $ = (s, r = document) => r.querySelector(s), $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const IO = 'IntersectionObserver' in window;
  const uma = (el, fn, opt) => { if (!el) return; if (!IO || reduz) return fn(); const io = new IntersectionObserver(([e]) => { if (e.isIntersecting) { io.disconnect(); fn(); } }, opt || { threshold: .25 }); io.observe(el); };

  // galeria: trilho com rolagem; pontos (celular) e miniaturas (desktop) seguem
  $$('.n2-gal').forEach(g => {
    const tr = $('.n2-gal__trilho', g), itens = $$('.n2-gal__item', g), bts = $$('[data-n2-ir]', g);
    const marca = i => bts.forEach(b => b.setAttribute('aria-current', String(+b.dataset.n2Ir === i)));
    bts.forEach(b => b.addEventListener('click', () => { const i = +b.dataset.n2Ir; tr.scrollTo({ left: itens[i].offsetLeft - tr.offsetLeft, behavior: reduz ? 'auto' : 'smooth' }); marca(i); }));
    let t; tr.addEventListener('scroll', () => { clearTimeout(t); t = setTimeout(() => marca(Math.round(tr.scrollLeft / tr.clientWidth)), 60); }, { passive: true });
    marca(0);
  });

  // opções: o rádio troca a variante do formulário; botão e barra fixa mostram o preço da escolhida
  const form = $('form[data-type="add-to-cart-form"]', $('#n2-pdp') || document);
  const idIn = form && $('input[name="id"]', form);
  const opts = $$('.n2-opt');
  function escolhe(vid, rolar) {
    const r = $(`.n2-opt input[value="${vid}"]`); if (!r) return;
    r.checked = true; if (idIn) { idIn.value = vid; idIn.dataset.selectedId = vid; }
    const opt = r.closest('.n2-opt'), ok = opt.dataset.disponivel === 'true';
    $$('[data-n2-comprar]').forEach(b => { b.toggleAttribute('disabled', !ok); b.setAttribute('aria-disabled', String(!ok)); });
    $$('[data-n2-preco]').forEach(n => { n.textContent = opt.dataset.preco; });
    $$('[data-n2-fixa-op]').forEach(b => b.setAttribute('aria-pressed', String(b.dataset.n2FixaOp === String(vid))));
    if (rolar) { const alvo = $('#n2-comprar'); alvo?.scrollIntoView({ behavior: reduz ? 'auto' : 'smooth', block: 'center' }); setTimeout(() => r.focus({ preventScroll: true }), reduz ? 0 : 500); }
  }
  opts.forEach(o => $('input', o).addEventListener('change', e => escolhe(e.target.value)));
  $$('[data-n2-escolhe]').forEach(b => b.addEventListener('click', () => escolhe(b.dataset.n2Escolhe, true)));
  $$('[data-n2-fixa-op]').forEach(b => b.addEventListener('click', () => escolhe(b.dataset.n2FixaOp)));
  $('[data-n2-fixa-add]')?.addEventListener('click', () => { const b = $('[data-n2-comprar]'); if (b && !b.disabled) b.click(); });
  const ini = $('.n2-opt input:checked'); if (ini) escolhe(ini.value);

  // barra fixa (celular): aparece quando o bloco de compra sai da tela por cima
  const fixa = $('[data-n2-fixa]'), bloco = $('#n2-comprar');
  if (fixa && bloco && IO) {
    document.body.classList.add('n2-com-fixa');
    new IntersectionObserver(([e]) => fixa.classList.toggle('is-on', !e.isIntersecting && e.boundingClientRect.top < 0), { threshold: 0 }).observe(bloco);
  }

  // comparação: a coluna Nette entra primeiro, as outras 200 ms depois (uma vez)
  const cmp = $('[data-n2-cmp]');
  if (cmp) uma(cmp, () => { $$('.n2-cmp__c--n', cmp).forEach(c => c.style.opacity = 1); setTimeout(() => cmp.classList.remove('is-pre'), reduz ? 0 : 260); });

  // rosto zona por zona: um item aberto por vez; o ponto da zona pulsa e a foto aproxima; o 04 troca a foto
  $$('.n2-zon').forEach(z => {
    const fig = $('[data-n2-fig]', z), its = $$('[data-n2-zona]', z);
    const abre = n => {
      its.forEach(it => { const on = it.dataset.n2Zona === String(n); it.classList.toggle('is-open', on); $('.n2-acc__bt', it).setAttribute('aria-expanded', String(on)); });
      fig.dataset.zone = n;
      $$('[data-n2-pt]', fig).forEach(p => { p.classList.remove('is-on'); if (p.dataset.n2Pt === String(n)) { void p.offsetWidth; p.classList.add('is-on'); } });
    };
    its.forEach(it => $('.n2-acc__bt', it).addEventListener('click', () => abre(it.classList.contains('is-open') ? 0 : it.dataset.n2Zona)));
    $$('[data-n2-pt]', fig).forEach(p => p.addEventListener('click', () => abre(p.dataset.n2Pt)));
  });

  // Après 40 ans: as 3 frases sobem uma por vez (uma vez)
  const q = $('[data-n2-q40]');
  if (q) { const lis = $$('.n2-q40__l li', q); uma($('.n2-q40__l', q), () => { lis.forEach((li, i) => setTimeout(() => { li.style.opacity = 1; li.style.transform = 'none'; }, reduz ? 0 : 380 * i)); setTimeout(() => q.classList.remove('is-pre'), reduz ? 0 : 380 * lis.length + 600); }, { threshold: .3 }); }

  // vídeos: carregam perto da tela; toca mudo só o cartão mais visível; toque pausa/retoma; "reduzir movimento" = parado com botão
  const vids = $$('.n2-vid');
  const liga = (f, play) => { const v = $('video', f); if (!v.src && v.dataset.src) { v.src = v.dataset.src; v.load(); }
    if (play) { v.play().then(() => f.classList.add('is-play')).catch(() => {}); } else { v.pause(); f.classList.remove('is-play'); } };
  if (vids.length && IO) {
    const vis = new Map();
    const io = new IntersectionObserver(es => {
      es.forEach(e => vis.set(e.target, e.intersectionRatio));
      if (reduz) return;
      let melhor = null, r = .55; vis.forEach((v, f) => { if (v >= r && !f.dataset.pausado) { r = v; melhor = f; } });
      vids.forEach(f => { const v = $('video', f); if (f === melhor) { if (v.paused) liga(f, true); } else if (!v.paused) liga(f, false); });
    }, { threshold: [0, .3, .55, .75, 1] });
    vids.forEach(f => io.observe(f));
  }
  vids.forEach(f => $('.n2-vid__pp', f).addEventListener('click', () => {
    const v = $('video', f); vids.forEach(o => { if (o !== f && !$('video', o).paused) { o.dataset.pausado = '1'; liga(o, false); } });
    if (v.paused || !v.src) { delete f.dataset.pausado; liga(f, true); } else { f.dataset.pausado = '1'; liga(f, false); }
  }));
  $$('.n2-vid__box').forEach(b => b.addEventListener('click', e => { if (e.target.closest('.n2-vid__pp')) return; $('.n2-vid__pp', b).click(); }));
  // pontos do carrossel de vídeos (celular)
  const tr = $('[data-n2-vids]'), pts = $$('.n2-vids__pts span');
  if (tr && pts.length) { const m = () => { const w = vids[0].offsetWidth + 12; const i = Math.min(pts.length - 1, Math.round(tr.scrollLeft / w)); pts.forEach((p, k) => p.classList.toggle('is-on', k === i)); }; tr.addEventListener('scroll', m, { passive: true }); m(); }

  // centro das duas cabeças: clipe do HyperFrames (se houver) toca uma vez quando aparece; "reduzir movimento" = pôster
  const tv = $('.n2-tet__centro video');
  if (tv && !reduz && IO) new IntersectionObserver(([e]) => { if (e.isIntersecting) { if (!tv.src) tv.src = tv.dataset.n2Src; tv.play().catch(() => {}); } else if (!tv.paused) tv.pause(); }, { threshold: .4 }).observe(tv);

  // topo: o LED do anel "acende" uma vez, depois que a foto-capa carrega (a única coisa que se move na abertura)
  const led = $('.n2-led'), capa = $('.n2-gal__item--capa img');
  if (led && capa && !reduz) (capa.decode ? capa.decode() : Promise.resolve()).then(() => requestAnimationFrame(() => led.classList.add('is-on'))).catch(() => {});
})();
